const SuccessViewBR = () => (
    <div className="success-container success-container-br text-center">
        <h5>
            <T>auth.sign.up.success.br</T>
        </h5>
    </div>
)

export default SuccessViewBR
